module.exports = __webpack_public_path__ + "fonts/fa-brands-400.913334b2.ttf";